import type React from 'react';
import {useEffect, useRef} from 'react';
import {useInView} from 'react-intersection-observer';
import {useInfiniteEngineerCompanyList} from '../../../../core/repositories/companyRepository';
import {EngineerCompaniesFramePresentation} from './presentation';

type Props = {
  componentID: string;
  filterQuery: {
    limit?: number;
    minEmployeeCount?: number;
    maxEmployeeCount?: number;
    workAttractiveConditionIDs?: number[];
  };
  handleSetTotalCount?: (key: string, count: number) => void;
};

export const EngineerCompaniesFrameContainer: React.FC<Props> = ({
  componentID,
  filterQuery,
  handleSetTotalCount,
}) => {
  const {ref, inView} = useInView({
    triggerOnce: true,
  });
  const {data, isLoading} = useInfiniteEngineerCompanyList({
    queryParams: {
      limit: 10,
      page: 1,
      minEmployeeCount: filterQuery.minEmployeeCount,
      maxEmployeeCount: filterQuery.maxEmployeeCount,
      workAttractiveConditionIDs: filterQuery.workAttractiveConditionIDs ?? [],
    },
    config: {
      enabled: inView,
    },
  });

  const companies = data?.pages.flatMap((page) => page.companies) ?? [];

  const prevCompaniesLength = useRef(0);

  useEffect(() => {
    if (handleSetTotalCount) {
      const currentLength = companies.length;
      if (currentLength !== prevCompaniesLength.current) {
        handleSetTotalCount(componentID, currentLength);
        prevCompaniesLength.current = currentLength;
      }
    }
  }, [companies.length, handleSetTotalCount, componentID]);

  if (companies.length === 0 && !isLoading) {
    return <></>;
  }

  return (
    <EngineerCompaniesFramePresentation
      ref={ref}
      componentID={componentID}
      isLoading={isLoading}
      companies={companies}
    />
  );
};
